// for general space functionality
// https://mccglc.atlassian.net/l/c/CmS2QaGN for DOCS

import { convertFromServerColourScheme } from "@/functions/colourSchemes.js"
import { processMediaURL } from '@/functions/utility.js';

const getters = {
  getHubInitialsTextScalar: () => 1.7,
  // get background colour for room circle depending on room type
  getRoomBGColor: (_, getters) => (room) => {
    if (room.color && room.color != "") {
      return room.color // room has a colour set by user, use that
    }

    let cs = convertFromServerColourScheme(getters.getCurrentAreaColourScheme);

    if(room.conferenceType === 'livestream'){
      return cs.livestream
    }

    return !cs ? '#000' : {
      hub: cs.hub,
      // "open" spaces should no longer exist, except they kind of do?
      open: cs.lounge,
      lounge: cs.lounge,
      digital: cs.temporary,
      hybrid: cs.fixed
      // default to digital space colour
    }[room.spaceType] || cs.temporary;
  },
  getRoomBGImage: () => (room) => {
    return processMediaURL(room.imageUrl)
  },
};

export default {
  getters
};
